import { render, staticRenderFns } from "./admin_analytics.vue?vue&type=template&id=5ba85a8a&scoped=true&"
import script from "./admin_analytics.vue?vue&type=script&lang=js&"
export * from "./admin_analytics.vue?vue&type=script&lang=js&"
import style0 from "./admin_analytics.vue?vue&type=style&index=0&id=5ba85a8a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba85a8a",
  null
  
)

export default component.exports